import UserManage from "./UserManage";
import Department from "./Department"

export default {
  UserManage,
  Department
}
